import { validateEnv } from "./env-schema";

export type { Env } from "./env-schema";
export { validateEnv } from "./env-schema";

export const env = validateEnv();
